module.exports = __webpack_public_path__ + "public/images/person-drawing.41909f8f9ae89b937c4c4c96eb9a99fc.png";